/*
 * Arquimed — sugerencias del buscador (autocompletado)
 * Usa la búsqueda predictiva de Shopify (/search/suggest.json) para mostrar,
 * mientras se escribe, palabras clave sugeridas, productos, categorías y páginas.
 * Se conecta a cualquier <form data-arq-suggest> que tenga un input name="q".
 */
(function () {
  if (window.arqSearchSuggestLoaded) return;
  window.arqSearchSuggestLoaded = true;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 160;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Quita tildes y pasa a minúsculas, carácter por carácter (mismo largo).
  function fold(s) {
    return Array.prototype.map.call(String(s), function (ch) {
      return ch.normalize ? ch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().charAt(0) || ch : ch.toLowerCase();
    }).join('');
  }

  // Resalta lo escrito dentro de un texto plano, sin importar tildes
  // ("eco" resalta "Ecó" en "Ecógrafo").
  function highlight(text, term) {
    text = String(text == null ? '' : text);
    var words = (term || '').trim().split(/\s+/).filter(Boolean).map(fold);
    if (!words.length) return esc(text);
    var f = fold(text);
    var marks = new Array(text.length);
    words.forEach(function (w) {
      var i = f.indexOf(w);
      while (i > -1) {
        for (var k = i; k < i + w.length; k++) marks[k] = true;
        i = f.indexOf(w, i + w.length);
      }
    });
    var out = '', open = false;
    for (var j = 0; j < text.length; j++) {
      if (marks[j] && !open) { out += '<mark>'; open = true; }
      if (!marks[j] && open) { out += '</mark>'; open = false; }
      out += esc(text.charAt(j));
    }
    return out + (open ? '</mark>' : '');
  }

  function money(price) {
    var n = parseFloat(price);
    if (!n) return '';
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n);
    } catch (e) {
      return '$' + Math.round(n).toLocaleString('es-CL');
    }
  }

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var ICON_SEARCH = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M13 13l4.5 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function Suggest(form) {
    this.form = form;
    this.input = form.querySelector('input[name="q"]');
    if (!this.input) return;
    this.id = 'arq-suggest-' + Math.random().toString(36).slice(2, 8);
    this.panel = document.createElement('div');
    this.panel.className = 'arq-suggest';
    this.panel.id = this.id;
    this.panel.hidden = true;
    form.appendChild(this.panel);
    form.classList.add('arq-suggest-host');

    this.input.setAttribute('role', 'combobox');
    this.input.setAttribute('aria-autocomplete', 'list');
    this.input.setAttribute('aria-controls', this.id);
    this.input.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('autocomplete', 'off');

    this.active = -1;
    this.timer = null;
    this.ctrl = null;
    this.bind();
  }

  Suggest.prototype.bind = function () {
    var self = this;
    this.input.addEventListener('input', function () {
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.fetch(self.input.value); }, DEBOUNCE_MS);
    });
    this.input.addEventListener('focus', function () {
      if (self.input.value.trim().length >= MIN_CHARS) self.fetch(self.input.value);
    });
    this.input.addEventListener('keydown', function (e) { self.onKey(e); });
    document.addEventListener('click', function (e) {
      if (!self.form.contains(e.target)) self.close();
    });
    this.panel.addEventListener('mousemove', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (opt) self.setActive(self.options().indexOf(opt), false);
    });
  };

  Suggest.prototype.options = function () {
    return Array.prototype.slice.call(this.panel.querySelectorAll('[role="option"]'));
  };

  Suggest.prototype.setActive = function (i, scroll) {
    var opts = this.options();
    opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
    this.active = i;
    if (i >= 0 && opts[i]) {
      opts[i].classList.add('is-active');
      opts[i].setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', opts[i].id);
      if (scroll !== false) opts[i].scrollIntoView({ block: 'nearest' });
    } else {
      this.input.removeAttribute('aria-activedescendant');
    }
  };

  Suggest.prototype.onKey = function (e) {
    if (this.panel.hidden) return;
    var opts = this.options();
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setActive(this.active + 1 >= opts.length ? 0 : this.active + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setActive(this.active - 1 < 0 ? opts.length - 1 : this.active - 1);
    } else if (e.key === 'Enter' && this.active >= 0 && opts[this.active]) {
      e.preventDefault();
      window.location.href = opts[this.active].getAttribute('href');
    } else if (e.key === 'Escape') {
      this.close();
    }
  };

  Suggest.prototype.close = function () {
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.setActive(-1);
  };

  Suggest.prototype.open = function () {
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  };

  Suggest.prototype.fetch = function (raw) {
    var q = raw.trim();
    if (q.length < MIN_CHARS) { this.close(); return; }
    if (cache[q]) { this.render(q, cache[q]); return; }
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = window.AbortController ? new AbortController() : null;
    var self = this;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=query,product,collection,page' +
      '&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    this.panel.classList.add('is-loading');
    fetch(url, { signal: this.ctrl ? this.ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data && data.resources && data.resources.results) || {};
        cache[q] = res;
        if (self.input.value.trim() === q) self.render(q, res);
      })
      .catch(function () {})
      .then(function () { self.panel.classList.remove('is-loading'); });
  };

  Suggest.prototype.render = function (q, res) {
    var id = this.id;
    var n = 0;
    var nextId = function () { return id + '-o' + (n++); };
    var searchUrl = root + 'search?q=';
    var html = '';

    var queries = (res.queries || []).slice(0, 5);
    var products = (res.products || []).slice(0, 4);
    var collections = (res.collections || []).slice(0, 3);
    var pages = (res.pages || []).slice(0, 2);

    if (queries.length) {
      html += '<div class="arq-suggest__group"><p class="arq-suggest__label">Sugerencias</p><ul role="presentation">';
      queries.forEach(function (s) {
        html += '<li role="presentation"><a role="option" id="' + nextId() + '" class="arq-suggest__query" href="' + esc(s.url || (searchUrl + encodeURIComponent(s.text))) + '">' +
          '<span class="arq-suggest__qicon">' + ICON_SEARCH + '</span><span>' + highlight(s.text, q) + '</span></a></li>';
      });
      html += '</ul></div>';
    }

    if (products.length) {
      html += '<div class="arq-suggest__group"><p class="arq-suggest__label">Productos</p><ul role="presentation">';
      products.forEach(function (p) {
        var image = p.image || (p.featured_image && p.featured_image.url);
        var price = money(p.price);
        html += '<li role="presentation"><a role="option" id="' + nextId() + '" class="arq-suggest__product" href="' + esc(p.url) + '">' +
          '<span class="arq-suggest__thumb">' + (image ? '<img src="' + esc(img(image, 120)) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
          '<span class="arq-suggest__pinfo"><span class="arq-suggest__ptitle">' + highlight(p.title, q) + '</span>' +
          '<span class="arq-suggest__pmeta">' + esc(p.vendor || '') + (price ? (p.vendor ? ' · ' : '') + '<b>' + esc(price) + '</b>' : '') + '</span></span></a></li>';
      });
      html += '</ul></div>';
    }

    var links = collections.map(function (c) { return { t: c.title, u: c.url, k: 'Categoría' }; })
      .concat(pages.map(function (p) { return { t: p.title, u: p.url, k: 'Página' }; }));
    if (links.length) {
      html += '<div class="arq-suggest__group"><p class="arq-suggest__label">Categorías y páginas</p><ul role="presentation">';
      links.forEach(function (l) {
        html += '<li role="presentation"><a role="option" id="' + nextId() + '" class="arq-suggest__link" href="' + esc(l.u) + '">' +
          '<span>' + highlight(l.t, q) + '</span><span class="arq-suggest__kind">' + l.k + ICON_ARROW + '</span></a></li>';
      });
      html += '</ul></div>';
    }

    if (!html) {
      html = '<p class="arq-suggest__empty">No encontramos sugerencias para «' + esc(q) + '». Presiona Enter para buscar igual.</p>';
    }

    html += '<a role="option" id="' + nextId() + '" class="arq-suggest__all" href="' + esc(searchUrl + encodeURIComponent(q)) + '">Ver todos los resultados para «' + esc(q) + '»' + ICON_ARROW + '</a>';

    this.panel.innerHTML = html;
    this.panel.setAttribute('role', 'listbox');
    this.active = -1;
    this.open();
  };

  function init() {
    document.querySelectorAll('form[data-arq-suggest]').forEach(function (f) {
      if (!f.arqSuggest) f.arqSuggest = new Suggest(f);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
